module.exports = __webpack_public_path__ + "img/cooperate_zf_02@2x.fa3bc2c9.png";